import { saveAs } from 'file-saver';

const getFilenameFromUrl = (url: string): string => {
  try {
    return new URL(url).pathname.split('/').pop() || 'downloaded-file';
  } catch {
    return 'downloaded-file';
  }
};

const getFilenameFromHeaders = (res: Response, fallback: string): string => {
  const disposition = res.headers.get('Content-Disposition');
  if (disposition) {
    const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';\n]+)["']?/i);
    if (match && match[1]) {
      return decodeURIComponent(match[1]);
    }
  }
  return fallback;
};

const resourceDownloadRequest = async (
  url: string,
  saveName?: string,
  customConfig?: RequestInit
) => {
  const config: RequestInit = {
    method: 'GET',
    headers: {
      'Accept': '*/*',
      ...(customConfig?.headers || {})
    },
    ...customConfig
  };

  const res = await fetch(url, config);

  if (!res.ok) {
    throw new Error(`Failed to fetch resource: ${res.status} ${res.statusText}`);
  }

  const blob = await res.blob();
  const filename = saveName || getFilenameFromHeaders(res, getFilenameFromUrl(url));
  saveAs(blob, filename);
};

export default resourceDownloadRequest;
